import { TaskCreate } from './TaskCreate';
import { TaskEdit } from './TaskEdit';
import { TaskList } from './TaskList';
import { TaskShow } from './TaskShow';

export const create = TaskCreate;
export const list = TaskList;
export const edit = TaskEdit;
export const show = TaskShow;
